module.exports = __webpack_public_path__ + "img/platform-personal.bae18d24.svg";